import RockPaperScissors from './components/RockPaperScissors'

import './App.css'

const App = () => <RockPaperScissors />

export default App
